import { MessageButton, MessageSelectList } from '../models/message.model';

export interface ParsedMessageContent {
  content: string;
  buttons?: MessageButton[];
  selectList?: MessageSelectList;
  retrievedArticles?: any;
  answeredMessageId?: string | null;
  agentName?: string | null;
  transferIntent?: string | null;
  requestKey?: string | null;
  agentTrace?: string | null;
}

/**
 * Parses message content to extract buttons, selectList from JSON formatted messages
 * Used by ChatService and ConversationVisualizerService
 */
export function parseMessageContent(text: string): ParsedMessageContent {
  try {
    const parsed = JSON.parse(text) as {
      type?: string;
      options?: Array<{ title: string; description?: string }>;
      buttons?: Array<{ title: string; description?: string }>;
      header?: string;
      body?: string;
      footer?: string;
      button?: string;
      title?: string;
    };

    // Usar buttons si existe, sino usar options (para compatibilidad)
    const buttonOptions = parsed?.buttons || parsed?.options;

    if ((parsed?.type === "list" || parsed?.type === "quick_reply") && Array.isArray(buttonOptions)) {
      // Contenido del mensaje
      const content = [parsed.header, parsed.body, parsed.footer]
        .filter(Boolean)
        .join("\n");
      
      // Si el tipo es "list", usar selectList
      if (parsed?.type === "list") {
        return {
          content: content,
          selectList: {
            placeholder: parsed.button || "Opciones",
            options: buttonOptions.map((opt) => ({
              label: opt.title + (opt.description ? " - " + opt.description : ""),
              value: opt.title,
            })),
          },
        };
      } else {
        // Si el tipo es "quick_reply", usar botones
        return {
          content: content,
          buttons: buttonOptions.map((opt) => ({
            label: opt.title,
            value: opt.title,
          })),
        };
      }
    }
  } catch (error) {
    // Not a JSON message, return as-is
  }
  return { content: text };
}
